export const getSourceSystem = currentFlow => {
  if (currentFlow.includes('API marketplace')) {
    return 'apim';
  }
  return '';
};
